import { first, get, keys, intersection, remove } from 'lodash'

export const ERRORS_CLEAR_GLOBAL = 'ERRORS_CLEAR_GLOBAL'
export const ERRORS_SET_GLOBAL = 'ERRORS_SET_GLOBAL'
export const ERRORS_CLEAR = 'ERRORS_CLEAR'
export const ERRORS_SET = 'ERRORS_SET'

export default {
  namespaced: true,

  state: {
    all: [],
    global: []
  },

  getters: {
    hasGlobalErrors: state => state.global.length > 0,

    getError (state) {
      return (field) => {
        return state.all.find((o) => field === o.name)
      }
    },

    hasError (state, getters) {
      return (field) => {
        return getters.getError(field) !== undefined
      }
    },

    getErrors (state) {
      return (fields) => {
        return state.all.filter((o) => fields.indexOf(o.name) !== -1)
      }
    },

    hasAnyErrors (state) {
      return (fields) => {
        return intersection(fields, keys(state.all)).length > 0
      }
    },

    getFirstGlobal (state) {
      if (state.global.length > 0) {
        return first(state.global, null)
      }

      return null
    },

    getFirstGlobalError (state) {
      return (field) => {
        if (state.global.length === 0) {
          return undefined
        }

        return first(get(first(state.global, {}), `errors.${field}`, []))
      }
    }
  },

  actions: {
    setError ({ commit }, [name, error, important]) {
      commit(ERRORS_SET, [name, error, important])
    },

    clearError ({ commit }, [name]) {
      commit(ERRORS_CLEAR, [name])
    },

    pushGlobalError ({ commit }, [error]) {
      commit(ERRORS_SET_GLOBAL, [error])
    },

    clearGlobalErrors ({ commit }) {
      commit(ERRORS_CLEAR_GLOBAL)
    }
  },

  mutations: {
    ERRORS_SET: (state, [name, error, important]) => {
      state.all.push({
        name: name,
        important: important || false,
        data: error
      })
    },

    ERRORS_CLEAR: (state, [name]) => {
      remove(state.all, function (o) { return o.name === name })

      state.all.splice(state.all.length, 0)
    },

    ERRORS_CLEAR_GLOBAL: (state) => {
      state.global = []
    },

    ERRORS_SET_GLOBAL: (state, [error]) => {
      state.global.push(error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/errors.js